define('bindingHandlers/switchedInclude',[
    'lib/lodash4',
    'lib/knockout',
    'bindingHandlers/include'
], function (_, ko, include) {
    'use strict';

    function getIncludeOptions (view, mappings) {
        return ko.computed(function () {
            var viewNames = Object.keys(mappings);
            var activeView = _.find(viewNames, function (viewName) {
                return !!ko.unwrap(view[viewName]);
            });

            var templateOptions = {
                if: !!activeView,  //Tell the template binding not to render if there's no active view
                data: view[activeView]
            };

            if(_.isObject(mappings[activeView])) {
                templateOptions.name = mappings[activeView].name;
                templateOptions.as = mappings[activeView].as;
            } else {
                templateOptions.name = mappings[activeView];
            }

            return templateOptions;
        });
    }

    /**
     * The switched include binding will check the current viewModel context or the provided
     * viewModel option for a defined property from the provides list of property -> template
     * mappings. If it finds a defined property, it will render the corresponding template
     * with the property as the data. Useful for working with SwitchedViews, but can be used
     * with any ViewModel.
     *
     * The template mapping can optional be an object with a 'name' and 'as' property if you
     * wish to provide an aliased template variable for the bound data.
     *
     * Usage with the current view context:
     *
     * data-bind="switchedInclude: {
     *      subView1: 'some/template'
     *      subView2: {
     *          name: 'some/otherTemplate',
     *          as: 'dataAlias'
     *     }
     * }"
     *
     * Usage with a specified view model:
     *
     * data-bind="switchedInclude: {
     *      viewModel: subViews,
     *      mappings: {
     *           subView1: 'some/template'
     *           subView2: {
     *              name: 'some/otherTemplate',
     *              as: 'dataAlias'
     *          }
     *      }
     * }"
     */
    ko.bindingHandlers.switchedInclude = {
        init: function (element, valueAccessor, allBindings, viewModel, bindingContext) {
            var options = ko.unwrap(valueAccessor());
            var view = options.viewModel ? ko.unwrap(options.viewModel) : viewModel;
            var mappings = options.viewModel ? ko.unwrap(options.mappings) : options;

            var includeOptions = getIncludeOptions(view, mappings);

            // Delegate to the include binding
            include.init(element, includeOptions, allBindings, viewModel, bindingContext);
            include.update(element, includeOptions, allBindings, viewModel, bindingContext);
            //Re-update include whenever the options computed changes
            var subscription = includeOptions.subscribe(function () {
                include.update(element, includeOptions, allBindings, viewModel, bindingContext);
            });

            //Clean up
            ko.utils.domNodeDisposal.addDisposeCallback(element, function() {
                includeOptions.dispose();
                subscription.dispose();
            });
        }
    };

    ko.virtualElements.allowedBindings.switchedInclude = true;

    return ko.bindingHandlers.switchedInclude;
});

